// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Smartcut$SmartcutsMacros = require("./Smartcut.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var CommandLog$SmartcutsMacros = require("./CommandLog.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var LoginSmartcut$SmartcutsMacros = require("./LoginSmartcut.bs.js");
var PlaybackValues$SmartcutsMacros = require("./PlaybackValues.bs.js");
var PlaybackOptions$SmartcutsMacros = require("./PlaybackOptions.bs.js");
var PlaybackTrigger$SmartcutsMacros = require("./PlaybackTrigger.bs.js");
var BgFx__GoogleSheet$SmartcutsMacros = require("./Bg/Fx/BgFx__GoogleSheet.bs.js");
var Browser__Identity$SmartcutsMacros = require("./browser/Browser__Identity.bs.js");
var ExtensionMessaging$SmartcutsMacros = require("./ExtensionMessaging.bs.js");
var GoogleSheetHelpers$SmartcutsMacros = require("./GoogleSheetHelpers.bs.js");
var ContentScript__StateMachine__Types$SmartcutsMacros = require("./ContentScript/StateMachine/ContentScript__StateMachine__Types.bs.js");

function viewable_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "GoogleSheet" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.optionFromJson(Decco.intFromJson, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* GoogleSheet */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ListOfPlaybackValues" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = PlaybackValues$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.listFromJson(PlaybackValues$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ListOfPlaybackValues */0,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function viewable_encode(v) {
  if (v.TAG === /* ListOfPlaybackValues */0) {
    return [
            "ListOfPlaybackValues",
            PlaybackValues$SmartcutsMacros.t_encode(v._0),
            Decco.listToJson(PlaybackValues$SmartcutsMacros.t_encode, v._1)
          ];
  } else {
    return [
            "GoogleSheet",
            Decco.stringToJson(v._0),
            Decco.optionToJson(Decco.intToJson, v._1)
          ];
  }
}

function stringify(v) {
  if (v.TAG === /* ListOfPlaybackValues */0) {
    return "ListOfPlaybackValues([size=" + (String(List.length(v._1) + 1 | 0) + "])");
  } else {
    return "GoogleSheet(" + (v._0 + (", firstNRows=" + (OptionUtils$SmartcutsMacros.stringify((function (prim) {
                        return String(prim);
                      }), v._1) + ")")));
  }
}

function onlyFirstNExecutions(nExecutions, batchData) {
  if (batchData.TAG === /* ListOfPlaybackValues */0) {
    return {
            TAG: /* ListOfPlaybackValues */0,
            _0: batchData._0,
            _1: ListUtils$SmartcutsMacros.take(nExecutions - 1 | 0, batchData._1)
          };
  } else {
    return {
            TAG: /* GoogleSheet */1,
            _0: batchData._0,
            _1: nExecutions
          };
  }
}

function size(batchData) {
  if (batchData.TAG === /* ListOfPlaybackValues */0) {
    return Promise.resolve(List.length(batchData._1) + 1 | 0);
  }
  var maybeOnlyFirstNRows = batchData._1;
  var spreadsheetId = batchData._0;
  return Browser__Identity$SmartcutsMacros.getAuthToken(true, true, undefined, undefined, undefined).then(function (maybeAccessToken) {
              var accessToken = OptionUtils$SmartcutsMacros.withDefault("Expected access token", maybeAccessToken);
              return GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined).then(function (client) {
                          return GoogleSheetHelpers$SmartcutsMacros.getSpreadsheetSize_withEdgeCaseHandling(spreadsheetId, accessToken, maybeOnlyFirstNRows, client);
                        });
            });
}

function fromPlaybackValuesArray(msgOpt, playbackValuesArray) {
  var msg = msgOpt !== undefined ? msgOpt : "Expected playbackValues to have at least 1 entry";
  var match = ArrayUtils$SmartcutsMacros.splitAtFirstExn(msg, playbackValuesArray);
  return {
          TAG: /* ListOfPlaybackValues */0,
          _0: match[0],
          _1: $$Array.to_list(match[1])
        };
}

function listOfPlaybackValues(firstPlaybackData, subsequentPlaybackData) {
  return {
          TAG: /* ListOfPlaybackValues */0,
          _0: firstPlaybackData,
          _1: subsequentPlaybackData
        };
}

function googleSheet(firstNRows, spreadsheetId) {
  return {
          TAG: /* GoogleSheet */1,
          _0: spreadsheetId,
          _1: firstNRows
        };
}

function getPlaybackValues(batchData, smartcutParams, loginSmartcuts, userCredentials) {
  if (batchData.TAG === /* ListOfPlaybackValues */0) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: List.append({
                      hd: batchData._0,
                      tl: /* [] */0
                    }, batchData._1)
              });
  } else {
    return BgFx__GoogleSheet$SmartcutsMacros.fetchRowsAndTransformToPlaybackData(smartcutParams, loginSmartcuts, userCredentials, batchData._0).then(function (result) {
                var tmp;
                tmp = result.TAG === /* Ok */0 ? ({
                      TAG: /* Ok */0,
                      _0: $$Array.to_list(result._0)
                    }) : ({
                      TAG: /* Error */1,
                      _0: result._0
                    });
                return Promise.resolve(tmp);
              });
  }
}

function view(batchData) {
  return batchData;
}

function viewable_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var executionSetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "executionSetId"), null));
  if (executionSetId.TAG === /* Ok */0) {
    var loadedSmartcut = Smartcut$SmartcutsMacros.LoadedSmartcut.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loadedSmartcut"), null));
    if (loadedSmartcut.TAG === /* Ok */0) {
      var userSpecifiedPlaybackOptions = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userSpecifiedPlaybackOptions"), null));
      if (userSpecifiedPlaybackOptions.TAG === /* Ok */0) {
        var maybeSmartcutDefaultPlaybackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSmartcutDefaultPlaybackOptions"), null));
        if (maybeSmartcutDefaultPlaybackOptions.TAG === /* Ok */0) {
          var startContext = PlaybackOptions$SmartcutsMacros.StartContext.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startContext"), null));
          if (startContext.TAG === /* Ok */0) {
            var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
            if (commandLog.TAG === /* Ok */0) {
              var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
              if (trigger.TAG === /* Ok */0) {
                var batchData = viewable_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "batchData"), null));
                if (batchData.TAG === /* Ok */0) {
                  var respondToPopup = Decco.optionFromJson(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "respondToPopup"), null));
                  if (respondToPopup.TAG === /* Ok */0) {
                    var rejectToPopup = Decco.optionFromJson(ExtensionMessaging$SmartcutsMacros.rejectToTab_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rejectToPopup"), null));
                    if (rejectToPopup.TAG === /* Ok */0) {
                      var removeRenderedContentOnTab = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "removeRenderedContentOnTab"), null));
                      if (removeRenderedContentOnTab.TAG === /* Ok */0) {
                        var smartcutName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutName"), null));
                        if (smartcutName.TAG === /* Ok */0) {
                          var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
                          if (origins.TAG === /* Ok */0) {
                            var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                            if (visibility.TAG === /* Ok */0) {
                              var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
                              if (numParams.TAG === /* Ok */0) {
                                var haveRequestedPermissions = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "haveRequestedPermissions"), null));
                                if (haveRequestedPermissions.TAG === /* Ok */0) {
                                  var loginUrls = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginUrls"), null));
                                  if (loginUrls.TAG === /* Ok */0) {
                                    return {
                                            TAG: /* Ok */0,
                                            _0: {
                                              executionSetId: executionSetId._0,
                                              loadedSmartcut: loadedSmartcut._0,
                                              userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions._0,
                                              maybeSmartcutDefaultPlaybackOptions: maybeSmartcutDefaultPlaybackOptions._0,
                                              startContext: startContext._0,
                                              commandLog: commandLog._0,
                                              trigger: trigger._0,
                                              batchData: batchData._0,
                                              respondToPopup: respondToPopup._0,
                                              rejectToPopup: rejectToPopup._0,
                                              removeRenderedContentOnTab: removeRenderedContentOnTab._0,
                                              smartcutName: smartcutName._0,
                                              origins: origins._0,
                                              visibility: visibility._0,
                                              numParams: numParams._0,
                                              haveRequestedPermissions: haveRequestedPermissions._0,
                                              loginUrls: loginUrls._0
                                            }
                                          };
                                  }
                                  var e = loginUrls._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".loginUrls" + e.path,
                                            message: e.message,
                                            value: e.value
                                          }
                                        };
                                }
                                var e$1 = haveRequestedPermissions._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".haveRequestedPermissions" + e$1.path,
                                          message: e$1.message,
                                          value: e$1.value
                                        }
                                      };
                              }
                              var e$2 = numParams._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".numParams" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                      }
                                    };
                            }
                            var e$3 = visibility._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".visibility" + e$3.path,
                                      message: e$3.message,
                                      value: e$3.value
                                    }
                                  };
                          }
                          var e$4 = origins._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".origins" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                  }
                                };
                        }
                        var e$5 = smartcutName._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".smartcutName" + e$5.path,
                                  message: e$5.message,
                                  value: e$5.value
                                }
                              };
                      }
                      var e$6 = removeRenderedContentOnTab._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".removeRenderedContentOnTab" + e$6.path,
                                message: e$6.message,
                                value: e$6.value
                              }
                            };
                    }
                    var e$7 = rejectToPopup._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".rejectToPopup" + e$7.path,
                              message: e$7.message,
                              value: e$7.value
                            }
                          };
                  }
                  var e$8 = respondToPopup._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".respondToPopup" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                          }
                        };
                }
                var e$9 = batchData._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".batchData" + e$9.path,
                          message: e$9.message,
                          value: e$9.value
                        }
                      };
              }
              var e$10 = trigger._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".trigger" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                      }
                    };
            }
            var e$11 = commandLog._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".commandLog" + e$11.path,
                      message: e$11.message,
                      value: e$11.value
                    }
                  };
          }
          var e$12 = startContext._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".startContext" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
        }
        var e$13 = maybeSmartcutDefaultPlaybackOptions._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".maybeSmartcutDefaultPlaybackOptions" + e$13.path,
                  message: e$13.message,
                  value: e$13.value
                }
              };
      }
      var e$14 = userSpecifiedPlaybackOptions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".userSpecifiedPlaybackOptions" + e$14.path,
                message: e$14.message,
                value: e$14.value
              }
            };
    }
    var e$15 = loadedSmartcut._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".loadedSmartcut" + e$15.path,
              message: e$15.message,
              value: e$15.value
            }
          };
  }
  var e$16 = executionSetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".executionSetId" + e$16.path,
            message: e$16.message,
            value: e$16.value
          }
        };
}

function viewable_encode$1(v) {
  return Js_dict.fromArray([
              [
                "executionSetId",
                Decco.stringToJson(v.executionSetId)
              ],
              [
                "loadedSmartcut",
                Smartcut$SmartcutsMacros.LoadedSmartcut.t_encode(v.loadedSmartcut)
              ],
              [
                "userSpecifiedPlaybackOptions",
                PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v.userSpecifiedPlaybackOptions)
              ],
              [
                "maybeSmartcutDefaultPlaybackOptions",
                Decco.optionToJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_encode, v.maybeSmartcutDefaultPlaybackOptions)
              ],
              [
                "startContext",
                PlaybackOptions$SmartcutsMacros.StartContext.t_encode(v.startContext)
              ],
              [
                "commandLog",
                CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
              ],
              [
                "trigger",
                PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
              ],
              [
                "batchData",
                viewable_encode(v.batchData)
              ],
              [
                "respondToPopup",
                Decco.optionToJson(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_encode, v.respondToPopup)
              ],
              [
                "rejectToPopup",
                Decco.optionToJson(ExtensionMessaging$SmartcutsMacros.rejectToTab_encode, v.rejectToPopup)
              ],
              [
                "removeRenderedContentOnTab",
                Decco.optionToJson(Decco.intToJson, v.removeRenderedContentOnTab)
              ],
              [
                "smartcutName",
                Decco.stringToJson(v.smartcutName)
              ],
              [
                "origins",
                Decco.arrayToJson(Decco.stringToJson, v.origins)
              ],
              [
                "visibility",
                Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
              ],
              [
                "numParams",
                Decco.intToJson(v.numParams)
              ],
              [
                "haveRequestedPermissions",
                Decco.boolToJson(v.haveRequestedPermissions)
              ],
              [
                "loginUrls",
                Decco.arrayToJson(Decco.stringToJson, v.loginUrls)
              ]
            ]);
}

var t_encode = viewable_encode$1;

var t_decode = viewable_decode$1;

function makeWithLoadedSmartcut(executionSetId, userSpecifiedPlaybackOptions, maybeSmartcutDefaultPlaybackOptions, startContext, commandLog, trigger, batchData, respondToPopup, rejectToPopup, removeRenderedContentOnTab, haveRequestedPermissionsOpt, loadedSmartcut) {
  var haveRequestedPermissions = haveRequestedPermissionsOpt !== undefined ? haveRequestedPermissionsOpt : false;
  var match = loadedSmartcut.smartcut;
  return {
          executionSetId: executionSetId,
          loadedSmartcut: loadedSmartcut,
          userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions,
          maybeSmartcutDefaultPlaybackOptions: maybeSmartcutDefaultPlaybackOptions,
          startContext: startContext,
          commandLog: commandLog,
          trigger: trigger,
          batchData: batchData,
          respondToPopup: respondToPopup,
          rejectToPopup: rejectToPopup,
          removeRenderedContentOnTab: removeRenderedContentOnTab,
          smartcutName: loadedSmartcut.name,
          origins: loadedSmartcut.origins,
          visibility: match.visibility,
          numParams: Smartcut$SmartcutsMacros.LoadedSmartcut.getNumParams(loadedSmartcut),
          haveRequestedPermissions: haveRequestedPermissions,
          loginUrls: match.loginUrls
        };
}

function view$1(startPlayback) {
  return startPlayback;
}

function onlyFirstNExecutions$1(nExecutions, startPlayback) {
  return {
          executionSetId: startPlayback.executionSetId,
          loadedSmartcut: startPlayback.loadedSmartcut,
          userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
          maybeSmartcutDefaultPlaybackOptions: startPlayback.maybeSmartcutDefaultPlaybackOptions,
          startContext: startPlayback.startContext,
          commandLog: startPlayback.commandLog,
          trigger: startPlayback.trigger,
          batchData: onlyFirstNExecutions(nExecutions, startPlayback.batchData),
          respondToPopup: startPlayback.respondToPopup,
          rejectToPopup: startPlayback.rejectToPopup,
          removeRenderedContentOnTab: startPlayback.removeRenderedContentOnTab,
          smartcutName: startPlayback.smartcutName,
          origins: startPlayback.origins,
          visibility: startPlayback.visibility,
          numParams: startPlayback.numParams,
          haveRequestedPermissions: startPlayback.haveRequestedPermissions,
          loginUrls: startPlayback.loginUrls
        };
}

function stringify$1(param) {
  return "{ executionSetId:" + (param.executionSetId + (", playbackOptions, startContext: " + (PlaybackOptions$SmartcutsMacros.StartContext.stringify(param.startContext) + (", commandLog, trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", batchData: " + (stringify(param.batchData) + (", respondToPopup, rejectToPopup, removeRenderedContentOnTab, smartcutName: " + (param.smartcutName + (", origins: [" + (param.origins.join(", ") + ("], visibility:  " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", numParams: " + (String(param.numParams) + " }")))))))))))))));
}

function minify(startPlayback) {
  return {
          executionSetId: startPlayback.executionSetId,
          loadedSmartcut: Smartcut$SmartcutsMacros.LoadedSmartcut.minify(startPlayback.loadedSmartcut),
          userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
          maybeSmartcutDefaultPlaybackOptions: startPlayback.maybeSmartcutDefaultPlaybackOptions,
          startContext: startPlayback.startContext,
          commandLog: CommandLog$SmartcutsMacros.GlobalForPlayback.minify(startPlayback.commandLog),
          trigger: startPlayback.trigger,
          batchData: startPlayback.batchData,
          respondToPopup: startPlayback.respondToPopup,
          rejectToPopup: startPlayback.rejectToPopup,
          removeRenderedContentOnTab: startPlayback.removeRenderedContentOnTab,
          smartcutName: startPlayback.smartcutName,
          origins: startPlayback.origins,
          visibility: startPlayback.visibility,
          numParams: startPlayback.numParams,
          haveRequestedPermissions: startPlayback.haveRequestedPermissions,
          loginUrls: startPlayback.loginUrls
        };
}

function executionSetIdGet(param) {
  return param.executionSetId;
}

function numExecutions(param) {
  return size(param.batchData);
}

function numCommands(param) {
  return List.length(param.commandLog);
}

function triggerGet(param) {
  return param.trigger;
}

function generatePlaybackOptions(param) {
  return PlaybackOptions$SmartcutsMacros.substituteInUserSpecifiedAndSmartcutDefaultOverrides(param.userSpecifiedPlaybackOptions, param.maybeSmartcutDefaultPlaybackOptions, param.startContext, param.loadedSmartcut.smartcut.msBeforeNextCommand, PlaybackOptions$SmartcutsMacros.defaultPlaybackOptions);
}

function determineInitialTab(param) {
  var startContext = param.startContext;
  if (startContext) {
    return startContext._0;
  }
  
}

function getTabIdOnWhichToRemoveRenderedContext(param) {
  return param.removeRenderedContentOnTab;
}

function loginSmartcutsGet(param) {
  return param.loadedSmartcut.smartcut.loginSmartcuts;
}

function doesNeedCredentials(startPlayback) {
  return !Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.isEmpty, loginSmartcutsGet(startPlayback));
}

function makeExecutionContext(startPlayback, executionId, firstPlaybackValues, subsequentPlaybackValues) {
  var match = startPlayback.loadedSmartcut;
  var match$1 = match.smartcut;
  var commandLogWithPlaybackParamValuesSubstitutedIn = PlaybackValues$SmartcutsMacros.substitutePlaybackValuesIntoCommandLog(startPlayback.commandLog, firstPlaybackValues);
  var sizeOfSet = 1 + List.length(subsequentPlaybackValues) | 0;
  return {
          installedSmartcutId: match.installedSmartcut.id,
          smartcutId: match$1.id,
          smartcutName: startPlayback.smartcutName,
          executionSetId: startPlayback.executionSetId,
          executionId: executionId,
          executionStatus: /* Running */0,
          commandLog: commandLogWithPlaybackParamValuesSubstitutedIn,
          playbackOptions: generatePlaybackOptions(startPlayback),
          userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
          numExpectedPlaybacks: sizeOfSet,
          numSucceeded: 0,
          numFailed: 0,
          numConsecutiveFailures: 0,
          subsequentPlaybackValues: subsequentPlaybackValues,
          trigger: startPlayback.trigger,
          windowRef: undefined,
          numParams: startPlayback.numParams,
          origins: startPlayback.origins,
          visibility: startPlayback.visibility,
          maybeMsBeforeCloseWindow: match$1.maybeMsBeforeCloseWindow,
          loginUrls: startPlayback.loginUrls,
          loginSmartcuts: match$1.loginSmartcuts,
          currCredentialDbIdsByHostname: firstPlaybackValues.credentialDbIdsByHostname,
          maybeLastUsedCredentialDbIdsByHostname: Caml_option.some(firstPlaybackValues.credentialDbIdsByHostname)
        };
}

function getPlaybackValues$1(param, userCredentials) {
  var match = param.loadedSmartcut;
  var smartcutParamsData = match.smartcutParamsData;
  if (smartcutParamsData.TAG === /* Decoded */0) {
    return getPlaybackValues(param.batchData, smartcutParamsData._0, match.smartcut.loginSmartcuts, userCredentials);
  } else {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: {
                  TAG: /* JsonDecodeArrayError */3,
                  _0: smartcutParamsData._0
                }
              });
  }
}

function getExtensionMessagingCallbacks(param) {
  return [
          param.respondToPopup,
          param.rejectToPopup
        ];
}

function batchDataGet(param) {
  return param.batchData;
}

function setBatchData(startPlayback, batchData) {
  return {
          executionSetId: startPlayback.executionSetId,
          loadedSmartcut: startPlayback.loadedSmartcut,
          userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
          maybeSmartcutDefaultPlaybackOptions: startPlayback.maybeSmartcutDefaultPlaybackOptions,
          startContext: startPlayback.startContext,
          commandLog: startPlayback.commandLog,
          trigger: startPlayback.trigger,
          batchData: batchData,
          respondToPopup: startPlayback.respondToPopup,
          rejectToPopup: startPlayback.rejectToPopup,
          removeRenderedContentOnTab: startPlayback.removeRenderedContentOnTab,
          smartcutName: startPlayback.smartcutName,
          origins: startPlayback.origins,
          visibility: startPlayback.visibility,
          numParams: startPlayback.numParams,
          haveRequestedPermissions: startPlayback.haveRequestedPermissions,
          loginUrls: startPlayback.loginUrls
        };
}

var BatchData = {
  viewable_encode: viewable_encode,
  viewable_decode: viewable_decode,
  stringify: stringify,
  onlyFirstNExecutions: onlyFirstNExecutions,
  size: size,
  fromPlaybackValuesArray: fromPlaybackValuesArray,
  listOfPlaybackValues: listOfPlaybackValues,
  googleSheet: googleSheet,
  getPlaybackValues: getPlaybackValues,
  view: view
};

exports.BatchData = BatchData;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.viewable_encode = viewable_encode$1;
exports.viewable_decode = viewable_decode$1;
exports.makeWithLoadedSmartcut = makeWithLoadedSmartcut;
exports.view = view$1;
exports.stringify = stringify$1;
exports.minify = minify;
exports.executionSetIdGet = executionSetIdGet;
exports.onlyFirstNExecutions = onlyFirstNExecutions$1;
exports.numExecutions = numExecutions;
exports.numCommands = numCommands;
exports.triggerGet = triggerGet;
exports.determineInitialTab = determineInitialTab;
exports.getTabIdOnWhichToRemoveRenderedContext = getTabIdOnWhichToRemoveRenderedContext;
exports.loginSmartcutsGet = loginSmartcutsGet;
exports.doesNeedCredentials = doesNeedCredentials;
exports.makeExecutionContext = makeExecutionContext;
exports.getPlaybackValues = getPlaybackValues$1;
exports.getExtensionMessagingCallbacks = getExtensionMessagingCallbacks;
exports.batchDataGet = batchDataGet;
exports.setBatchData = setBatchData;
/* Smartcut-SmartcutsMacros Not a pure module */
